import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import { themr } from '../react-css-themr'
import { NAVIGATION } from '../identifiers'
import InjectButton from '../button/Button'
import InjectLink from '../link/Link'

const factory = (Button, Link) => {
  const Navigation = ({
    actions = [],
    children,
    className = '',
    routes = [],
    theme,
    type = 'horizontal',
  }) => {
    const _className = cx(theme[type], className)
    const buttons = actions.map((action, index) => (
      <Button className={theme.button} key={index} {...action} />
    ))

    const links = routes.map((route, index) => (
      <Link className={theme.link} key={index} {...route} />
    ))

    return (
      <nav data-react-toolbox='navigation' className={_className}>
        {links}
        {buttons}
        {children}
      </nav>
    )
  }

  Navigation.propTypes = {
    actions: PropTypes.array,
    children: PropTypes.node,
    className: PropTypes.string,
    routes: PropTypes.array,
    theme: PropTypes.shape({
      button: PropTypes.string,
      horizontal: PropTypes.string,
      link: PropTypes.string,
      vertical: PropTypes.string,
    }),
    type: PropTypes.oneOf(['vertical', 'horizontal']),
  }

  return Navigation
}

const Navigation = factory(InjectButton, InjectLink)
export default themr(NAVIGATION)(Navigation)
export { factory as navigationFactory }
export { Navigation }
